import DataTable from 'react-data-table-component';
import React, { useEffect, useState } from 'react'
import Rdcreatenewpart from './rdcreatenewpartb';
import Rdcreateeditpart from './rdcreateeditpartb';
import FetchApi from '../../../customhooks/functionFetchApi';
import RdApproveState from './rdapproveState';
import { FaFilePdf, FaFileSignature, FaCheckCircle } from "react-icons/fa";

function Actionall({ journalId, codeid, stateflow ,totalpartb}) {
    const FetchApis = new FetchApi();
    // const [checkdata, setCheckdata] = useState(false);

    // useEffect(() => {
    //     FetchApis.FethcGet(`/technical/techniaclByJournalId/${journalId}`).then((res) => {
    //         console.log(res)
    //         if (res.status == 200) {
    //             if (res.data.data.length > 0) {
    //                 setCheckdata(true)
    //             } else {
    //                 setCheckdata(false)
    //             }
    //         }
    //     })
    // }, [])

    return (
        <div className='row-page'>
            {totalpartb == 0 ? <Rdcreatenewpart datavalues={journalId} /> :
                <div className='row-page' >
                    <RdApproveState idjournal={journalId} stateflow={stateflow} />
                    <Rdcreateeditpart datavalues={journalId} codeid={codeid} stateflow={stateflow} /></div>
            }
        </div>
    )
}

const columns = [
    {
        name: 'TDS code',
        sortable: true,
         grow: 1,
        selector: row => row.tdscode,
    },
    {
        name: 'V',
        grow: 0.1,
        selector: row => row.revision,
    },
    {
        name: 'Journal Type',
        grow: 1.5,
        selector: row => <div>
            {row.journaltype}
            <div style={{ color: 'red' }}>Create by: {row.createbyName}</div>
        </div>,
    },
    {
        name: 'customer / product',
        grow: 1.5,
        selector: row => <div>
            <div>customer : {row.customername}</div>
            <div>product : {row.productname}</div>
            <div style={{ color: '#E85107' }}>product type : {row.productgrouptype}</div>
        </div>,
    },
    // {
    //     name: 'product name',
    //     selector: row => row.productname,
    // },
    {
        name: 'job status',
        selector: row => <div>{row.statusprove_Tds == 1 && <label style={{ color: '#0e9a07' }}><FaCheckCircle /> proof job</label>}</div>,
    },
    {
        name: 'confirm job',
        selector: row => <div>{row.statusConfirm == 1 && <label style={{ color: '#0e9a07' }}><FaCheckCircle />Approve</label>}</div>,
    },
    {
        name: 'createdate',
        selector: row => row.createdate,
    },
    {
        name: 'Action',
        grow: 1.5,
        cell: row => <Actionall journalId={row.journalId} codeid={row.tdscode} stateflow={row.stateflow}  totalpartb={row.totalpartb}/>
        ,
    },

];

const customStyles = {
    headRow: {
        style: {
            border: 'none',
            backgroundColor: '#28B463'
        },
    },
    headCells: {
        style: {
            color: '#ffff',
            fontSize: '14px',
        },
    },
    rows: {
        highlightOnHoverStyle: {
            backgroundColor: 'rgb(230, 244, 244)',
            borderBottomColor: '#FFFFFF',
            borderRadius: '25px',
            outline: '1px solid #FFFFFF',
        },
    },
    pagination: {
        style: {
            border: 'none',
        },
    },
};



const Journaltablenewpartb = (datatable) => {
    var dataresult = datatable.datatable;

    return (

        <DataTable
            columns={columns}
            data={dataresult}
            // selectableRows
            pagination
            customStyles={customStyles}
            highlightOnHover

        />
    )
}

export default Journaltablenewpartb